import { SCHOOL_ASSISTANTS } from './actionsType'
import { requestWithPromise } from '../../utils'
import { dispatchIfData } from '../../utils/apiHelper'
import { getAllAssistants } from '../../utils/api/assistant'

const {
  SET_ASSISTANTS,
  REMOVE_ASSISTANT,
  SET_SCHOOL_SPECIALITIES
} = SCHOOL_ASSISTANTS

export const getSchoolAssistants = state => {
  return state.schoolAssistants
}

export const fetchAssistants = (user, setLoading) => {
  return async (dispatch, getState) => {
    getAllAssistants(user).then(response => {
      dispatchIfData(dispatch, SET_ASSISTANTS, response)
      setLoading(false)
    })
  }
}

export const removeAssistant = ({ assistantId, user }) => {
  return async (dispatch, getState) => {
    requestWithPromise(
      `/api/assistants/${assistantId}`, 'DELETE', null, user
    ).then(response => {
      dispatchIfData(dispatch, REMOVE_ASSISTANT, { data: assistantId })
    })
  }
}

export const fetchSchoolSpecialities = user => {
  return async (dispatch, getState) => {
    requestWithPromise(
      '/api/school-specialities', 'GET', null, user
    ).then(response => {
      dispatchIfData(dispatch, SET_SCHOOL_SPECIALITIES, response)
    })
  }
}
